import { WarningImage } from '@approvalmax/ui';
import { Flex, Text } from '@approvalmax/ui/src/components';
import { FC, memo } from 'react';

import { messages } from './EmptyBillsSection.messages';
import { EmptyBillsSectionProps } from './EmptyBillsSection.types';

export const EmptyBillsSection: FC<EmptyBillsSectionProps> = memo((props) => {
    const { selectableBills, isLoading } = props;

    if (selectableBills.length !== 0 || isLoading) {
        return null;
    }

    return (
        <Flex direction='column' alignItems='center' justifyContent='center' spacing='20 0'>
            <WarningImage />

            <Text font='body' fontSize='large' fontWeight='medium'>
                {messages.emptyBillsText}
            </Text>
        </Flex>
    );
});

EmptyBillsSection.displayName = 'EmptyBillsSection';
